const fn = (
  properties = [],
  { seconds = '0.25s', type = 'ease-out' } = {}
) => {
  return properties.map((prop) => `${prop} ${seconds} ${type} `).join(', ');
};

export default fn;